import { BASE_API } from "../Config/Config";

export const fetchtenderapi = async () => {
    try {
        const response = await fetch(`${BASE_API}/apis/tenderShow.php`, {
            method: "POST",
        });

        const result = await response.json();

        if (result.status === "success") {
            return result.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error("Fetch Tenders Error:", error);
        return [];
    }
};

export const fetchadmintenderapi = async () => {
    try {
        const response = await fetch(`${BASE_API}/apis/admintenderShow.php`, {
            method: "POST",
            credentials: "include",
        });

        const result = await response.json();

        if (result.status === "success") {
            return result.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error("Fetch Tenders Error:", error);
        return [];
    }
};